<template>
    <div id="highTaskExamineByLaws">
        <Headers :headersText='headersText'></Headers>
        <!-- 文字说明 -->
        <div class="boxPadding">
            <div class="textExplain">
                <div>*每个任务都需要提交审核</div>
                <div>*请确保提交审核的信息与做任务的信息一致，避免审核不能通过</div>
                <div>*您所提交的信息，钱大师官方予以保密</div>
                <div>*审核将在两个工作日内完成，请耐心等候</div>
            </div>
        </div>
    </div>
</template>

<script>
    import Headers from '../components/headers'
    export default {
        components:{
            Headers
        },
        data() {
            return {
                headersText:'提交审核细则',
            }
        },
        methods: {
            
        },
    }
</script>

<style lang="less" scoped>
    #highTaskExamineByLaws{
        // 文字说明
        .boxPadding{
            padding-bottom: 15px;
            .textExplain{
                width:309px;
                background:rgba(255,255,255,1);
                box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
                border-radius:5px;
                border:1px solid rgba(222,222,222,1);
                margin: 15px 15px 0;
                padding: 15px 21px 15px 15px;
                div{
                    font-size:13px;
                    font-weight:400;
                    color:#111111;
                    line-height:18px;
                    &:not(:first-of-type){
                        margin-top: 20px;
                    }
                }
            }
        }
    }
</style>